<template>
    <div class="m-common">
        <div class="common">
            <div v-if="articleLists">
                <div class="control-height">
                    <nav class="down-pull">
                    <div class="pull pull1">
                        <div class="title">{{pull1Current.value}}</div>
                        <ul>
                            <li @click="changPull1(item)" v-for="(item,index) in pull1" :key="index">{{item.value}}</li>
                        </ul>
                        <i></i>
                    </div>
                    <div class="pull pull2"> 
                        <div class="title">{{pull2Current.value}}</div>
                        <ul>
                            <li @click="changPull2(item)" v-for="(item,index) in pull2" :key="index">{{item.value}}</li>
                        </ul>
                        <i></i>
                    </div>
                    <div class="pull pull3"> 
                        <div class="title">{{pull3Current.value}}</div>
                        <ul>
                            <li @click="changPull3(item)" v-for="(item,index) in pull3" :key="index">{{item.value}}</li>
                        </ul>
                        <i></i>
                    </div>
                </nav>
                <article-market @marketSearch=cityParamSearch v-if="isShowMarket || clusterCityLists.length" :clusterCityLists=clusterCityLists></article-market>
                <article class="paragraph" v-for="(item,index) in articleLists" :key="index">
                    <strong><a :href="item.url" target="_blank" v-html="item.title" @click="countAd(4254)"></a></strong>
                    <a :href="item.url" class="docLink" target="_blank" @click="countAd(4254)">
                        <div class="doc" v-html="item.summary"></div>
                    </a>
                    <div class="paragraphInfo">
                        <span><i>分类：</i>{{item.cluster_channel}}</span>
                        <span><i>作者：</i>{{item.author || item.input_userid}}</span>
                        <span><i>时间：</i>{{item.pub_date}}</span>
                    </div>
                </article>
                <paging :totalPages=totalPages ref="paging" @reqData=reqArticleCms></paging>                
                </div>
                <search-box :id="2"></search-box>
            </div>
            <error-acrticle v-else :id="4255"></error-acrticle>
        </div>
        <common-side v-if="resultRes" :serailRightData=serailRightData :RightCarsConcern=RightCarsConcern :brandOrVendorRightData=brandOrVendorRightData :RightBrandOrVendorMyConcern=RightBrandOrVendorMyConcern></common-side>
    </div>
</template>

<script>
import ErrorAcrticle from '../../global/ErrorAcrticle.vue'
import ArticleMarket from './ArticleMarket.vue'
import CommonSide from '../../sides/Common'

    export default {
  components: { ErrorAcrticle, ArticleMarket, CommonSide },
      name: 'Common',
        data() {
            return {
                pull1Current: {value: '最相关', param:'', id: ''}, //第一个下拉框的当前列
                pull2Current: {value: '全部', param:'', id: ''}, //第三个下拉框的当前列
                pull3Current: {value: '全部时间', param:'', id: ''}, //第四个下拉框的当前列
                pull1: [
                    {value: '最相关', param:'', id: 1},
                    {value: '最新发布', param:'time', id: 2},
                    {value: '最热门', param:'access', id: 3},
                ],
                pull2: [],
                pull3: [    
                    {value: '全部时间', param:'', id: 1},
                    {value: '一周内', param:'week', id: 2},
                    {value: '一个月内', param:'month', id: 3},
                    {value: '一年内', param:'year', id: 4},
                ],
                articleLists: [], //文章数据
                totalPages: 1, //总页数
                clusterCityLists: [], //行情时的数据
                isShowMarket: false, //控制显示行情
                resultRes: {}, //结果数据
                /* 
                *请求参数 
                */
                pageNo: 1, //请求页数
                sort:'', //排序
                clusterQuery: '', //类型
                searchTime: '', //查询时间类型
                clusterCity: '', //城市参数(行情时)
                enableHomonym: true, //同音词搜索

                serailRightData: {}, //车系专区模块数据
                brandOrVendorRightData: {}, //品牌专区模块数据
                
                RightCarsConcern: [], //右侧车系可能关注
                RightBrandOrVendorMyConcern: [], //右侧品牌可能关注
            }
        },
        methods: {
            changPull1(item) {
                this.countAd(4251)
                if(item.value === this.pull1Current.value) return
                this.pull1Current = item
                this.sort = item.param
                this.reqArticleCms(this.pageNo)
            },
            changPull2(item) {
                this.countAd(4252)
                if(item.value === this.pull2Current.value) return
                this.pull2Current = item
                this.clusterQuery = item.param
                if(item.value != "行情") {this.isShowMarket = false}
                this.reqArticleCms(this.pageNo)
            },
            changPull3(item) {
                this.countAd(4253)
                if(item.value === this.pull3Current.value) return
                this.pull3Current = item
                this.searchTime = item.param
                this.reqArticleCms(this.pageNo)
            },
                 //重置搜索参数
            restParam() {
                this.sort = ''
                this.clusterQuery = ''
                this.searchTime = ''
                this.clusterCity = ''
            },
            async reqArticleCms(pageNo = 1) {
                try {
                    const res = await this.fetArticleCms({
                        q:this.$global.q,
                        sort:this.sort,
                        clusterQuery:this.clusterQuery,
                        searchTime:this.searchTime,
                        enableHomonym:this.enableHomonym,
                        clusterCity:this.clusterCity,
                        pageNo,
                    })
                    this.clusterCityLists = res.clusterCityResult
                    this.articleLists = res.result
                    this.totalPages = res.totalPage
                    this.$global.qType = res.type
                    this.resultRes = res
                    this.pageNo = pageNo
                    if(res) {
                        document.body.scrollTop = document.documentElement.scrollTop = 0
                    }
                    if(res.clusterResult) {
                        const clusterResult = Object.keys(res.clusterResult).map(v => {
                            return {value:v,param:v,id:res.clusterResult[v]}
                        })
                        this.pull2 = [{value: '全部', param:'', id: ''}]
                        this.pull2.push(...clusterResult)
                    }
                    if(!res) {
                        this.restParam()
                    }
                    if(res.type === 1 ) {
                        this.reqRightBrand(res.id)
                        this.reqBrandConcern(res.id)
                    }else if(res.type === 2) {
                        this.reqVdendorConcern(res.id)
                        this.reqRightVendor(res.id)
                    } else if(res.type === 3) {
                        this.reqRightCars(res.id,this.$global.rid)
                        this.reqRightCarsConcern(res.id)
                    }
                } catch (error) {
                    console.error(error)
                }
            },
            //请求右侧豆腐块车系专区模块数据
            async reqRightCars(sid,city) {
                try {
                    const res = await this.fetRightCars({
                        sid,
                        city
                    })
                    this.serailRightData = res
                } catch (error) {
                    console.error(error)
                }
            },
            //请求右侧豆腐块品牌专区模块数据 
            async reqRightBrand(bid) {
                try {
                    const res = await this.fetRightBrand({
                        bid
                    })
                    this.brandOrVendorRightData = res
                } catch (error) {
                    console.error(error)
                }
            },
            //请求右侧豆腐块厂商专区模块数据 
            async reqRightVendor(fid) {
                try {
                    const res = await this.fetRightVendor({
                        fid
                    })
                    this.brandOrVendorRightData = res
                } catch (error) {
                    console.error(error)
                }
            },            
            //请求右侧豆腐块车系可能关注模块数据 
            async reqRightCarsConcern(sid) {
                try {
                    const res = await this.fetRightCarsConcern({
                        sid
                    })
                    this.RightCarsConcern = res
                } catch (error) {
                    console.error(error)
                }
            },
            //请求右侧豆腐块品牌可能关注模块数据 
            async reqBrandConcern(bid) {
                try {
                    const res = await this.fetBrandConcern({
                        bid
                    })
                    this.RightBrandOrVendorMyConcern = res
                } catch (error) {
                    console.error(error)
                }
            },      
            //请求右侧豆腐块厂商可能关注模块数据 
            async reqVdendorConcern(fid) {
                try {
                    const res = await this.fetVdendorConcern({
                        fid
                    })
                    this.RightBrandOrVendorMyConcern = res
                } catch (error) {
                    console.error(error)
                }
            },                  
            cityParamSearch(city) {
                this.clusterCity = city
                this.isShowMarket = true
                this.reqArticleCms()
            },

        },
        mounted() {
            // if(this.$global.tab.title == 'auto_cms') {
                this.countColumnAd(3449)
                this.reqArticleCms(this.pageNo)
                // this.$EventBus.$on(`${this.$global.tab.title}`,() => {this.reqArticleCms(this.pageNo)})
            // }
        }
    }
</script>

<style lang="scss" scoped>
.m-common {
    display: flex;
    justify-content: space-between;
    width: 100%;
}
.common {
    width: 620px;
    .down-pull {
        display: flex;
        color: #225599;
        border-bottom: 1px solid #eeeeee;
        height: 46px;
        align-items: center;
        .pull {
            height: 28px;
            line-height: 28px;
            position: relative;
            margin-left: 10px;
            box-sizing: border-box;
                i {
                    display: block;
                    width: 7px;
                    height: 4px;
                    position: absolute;
                    right: 8px;
                    top: 11px;
                    overflow: hidden;
                    background-image: url($imageURL);
                    background-position: -8px -29px;
                }
            .title {
                width: 80px ;
                border: 1px solid transparent;
                padding-left: 6px;
                cursor: pointer;
                background-color: #fcfcfc;
            }
            ul {
                position: absolute;
                top: 28px;
                left: 0;
                display: none; 
                background-color: #fcfcfc; 
                width: 80px;
                cursor: pointer;
                color: #777777;
                z-index: 88;
            }
            &.pull1 {
                &:hover {
                    ul{
                        display: block;
                        border: 1px solid #e5e5e5;
                    }
                    i {
                        transform: rotate(180deg);
                    }
                }
            }
            &.pull2 {
                &:hover {
                    ul{
                        display: block;
                        border: 1px solid #e5e5e5;
                    }
                    i {
                        transform: rotate(180deg);
                    }
                }
            }
            &.pull3 {
                &:hover {
                    ul{
                        display: block;
                        border: 1px solid #e5e5e5;
                    }
                    i {
                        transform: rotate(180deg);
                    }
                }
            }
            li {
                width: 100%;
                padding-left: 6px;
                box-sizing: border-box;
                &:hover {
                    background-color: #f3f3f3;
                    color: #225599;
                }
            }
            &:first-of-type {
                margin-left: 0;
            }
        }
    }
    .paragraph {
        margin-top: 25px;
        strong {
            font-weight: normal;
            font-size: 16px;
            line-height: 32px;
            a {
                text-decoration: underline;
                color: #225599;
                ::v-deep em {
                    color: #cc0000;
                    text-decoration: underline;
                    font-style: normal;
                }
            }
        }
        .docLink {
            text-decoration: none;
            display: block;
            .doc {
                color: #333333;
                line-height: 22px;
                overflow: hidden;
                position: relative;
                ::v-deep em {
                    color: #cc0000;
                    font-style: normal;
                }
            }
        }
        .paragraphInfo {
            span {
                width: 120px;
                display: inline-block;
                color: #333333;
                height: 20px;
                overflow: hidden;
                word-break: break-all;
                word-wrap: break-word;
                margin-right: 5px;
                i {
                    color: #777777;
                    font-style: normal;
                }
            }
        }
    }
}
</style>